import Header from './components/Header';
import Hero from './components/Hero';
import Comments from './components/Comments';
import IndexSection from './components/IndexSection';
import Ranking from './components/Ranking';
import Topics from './components/Topics';
import Features from './components/Features';
import About from './components/About';
import Contact from './components/Contact';
import Updates from './components/Updates';
import AppSection from './components/AppSection';
import Carousel from './components/Carousel';
import Cards from './components/Cards';
import Faq from './components/Faq';
import Media from './components/Media';
import Footer from './components/Footer';

export default function Home() {
  return (
    <>
      <Header />
      <main>
        <Hero />
        <Comments />
        <IndexSection />
        <Ranking />
        <Topics />
        <Features />
        <About />
        <Contact />
        <Updates />
        <AppSection />
        <Carousel />
        <Cards />
        <Faq />
        <Media />
      </main>
      <Footer />
    </>
  );
}